import {getBaseUrl} from "../utils/FetchUtil";
import Cookies from "js-cookie";

export default function FetchWrapper(url, options) {
  return sendRequest(getBaseUrl() + url, options);
}

const sendRequest = (url, options) => {
  let config = {};
  const token = Cookies.get('token');

  const getHeaders = (headers) => {
    const authHeader = `Bearer ${token}`;
    if (headers) {
      return {...headers, 'authorization': authHeader}
    } else {
      return {'authorization': authHeader}
    }
  };

  if (token) {
    if (options) {
      config = {...options, headers: getHeaders(options.headers)}
    } else {
      config = {headers: getHeaders()}
    }
  } else {
    config = options
  }

  return fetch(url, config).then(async response => {
    if (response.status === 401) {
      return Promise.reject("Unauthorized");
      /*return store.dispatch(
          refreshTokenAction(Cookies.get(CookieConstants.refreshToken))).then(
          () => {
            return sendRequest(url, options);
          });*/
    } else if (response.status === 204) {
      return Promise.resolve({});
    }

    return response.json();
  }).then(json => {
    if (!json || (json.status && json.status !== 200)) {
      return Promise.reject(
          json ? json.message : "Error occurred, please try again later");
    }

    return json;
  });
}
